// Dutch fantasy names
export const nlElfPrefixes = [
    "Aer", "An", "Ar", "Cal", "Cor", "El", "Eru", "Fa", "Fin", "Gal", "Gil", "Hal", "Il", "La", "Leg", "Lo",
    "Mal", "Mor", "Nar", "Nyd", "O", "Pa", "Ra", "Ril", "Sa", "Syl", "Ta", "Th", "Ty", "Val", "Wil", "Xa", "Yr", "Ze",
    "Ael", "Cael", "Dael", "Fael", "Gael", "Kael", "Lael", "Mael", "Nael", "Pael", "Rael", "Sael", "Tael", "Vael",
    "Ad", "Be", "Ce", "De", "Fe", "Ge", "He", "Je", "Ke", "Le", "Me", "Ne", "Pe", "Re", "Se", "Te", "Ve", "We", "Ye", "Ze",
    "Aal", "Bal", "Dal", "Fal", "Gal", "Hal", "Jal", "Kal", "Lal", "Mal", "Nal", "Pal", "Ral", "Sal", "Tal", "Val", "Wal", "Yal", "Zal"
];

export const nlElfSuffixes = [
    "ag", "ar", "as", "bor", "dil", "dor", "drim", "duin", "el", "eth", "fal", "fin", "gal", "gil", "hyl", "ian",
    "il", "in", "lan", "las", "lin", "lion", "lyn", "mar", "mir", "mus", "ndil", "or", "orn", "oth", "qual", "quar",
    "riel", "rin", "ron", "th", "thir", "uil", "um", "we", "wyn", "y", "a", "e", "i", "o", "u", "ae", "ea", "ia",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us"
];

export const nlMagicPrefixes = [
    "Al", "Bal", "Cor", "Dar", "El", "Ex", "Fal", "Gan", "Ig", "Kas", "Mal", "Mer", "Mor", "Nec", "Oz", "Phi",
    "Ras", "Sar", "Sol", "Thal", "Var", "Xan", "Zar", "Zed", "Zor", "Arc", "Bar", "Car", "Dor", "Er", "Far", "Gor",
    "Har", "Jar", "Kar", "Lor", "Mar", "Nor", "Par", "Qor", "Rar", "Sor", "Tor", "Vor", "War", "Xor", "Yar", "Zor",
    "Aal", "Bal", "Dal", "Fal", "Gal", "Hal", "Jal", "Kal", "Lal", "Mal", "Nal", "Pal", "Ral", "Sal", "Tal", "Val", "Wal", "Yal", "Zal"
];

export const nlMagicSuffixes = [
    "agar", "an", "ar", "ax", "bar", "dalf", "din", "dor", "drak", "ius", "kal", "mar", "min", "mond", "nar",
    "or", "os", "rak", "rin", "th", "tor", "us", "zor", "gorn", "dalf", "zar", "zim", "zog", "zum", "zax", "zix",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us"
];

export const nlDragonPrefixes = [
    "Ag", "Bal", "Chrom", "Dra", "Faf", "Gla", "Ign", "Kal", "Mal", "Ner", "On", "Pha", "Rha", "Sau", "Sma", "Thal",
    "Ver", "Vul", "Xan", "Zyr", "Aer", "Ber", "Cer", "Der", "Fer", "Ger", "Her", "Jer", "Ker", "Ler", "Mer", "Ner",
    "Drag", "Dragu", "Dragi", "Drago", "Dragr", "Dragl", "Dragm", "Dragn"
];

export const nlDragonSuffixes = [
    "ar", "ax", "bor", "don", "drax", "gon", "gorn", "ian", "ius", "lax", "lor", "mol", "nos", "or", "oth", "rax",
    "rion", "th", "tor", "us", "ver", "zor", "drog", "grog", "smog", "snog", "zog", "zrog", "zsmog", "zsnog",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us"
];
